export default "__VITE_ASSET__0b4011b5__"